import { useEffect, useState } from 'react';
import t from 'react-translate';
import NvDropdown, { NvDropdownButtonStyle, NvDropdownAlign, NvDropdownOption } from 'shared/components/inputs/nv-dropdown';
import { AdminUser } from 'redux/schemas/models/help-options';
import EditTagField from './edit-tag-field';

interface TagListAutocompleteProps {
  items: AdminUser[];
  onCancel: () => void;
  onAdd: (id: number) => void;
}

const TagListAutocomplete: React.FC<TagListAutocompleteProps> = ({
  items,
  onCancel,
  onAdd,
}) => {
  const [showList, setShowList] = useState(false);
  const [value, setValue] = useState('');
  const [filteredItems, setFilteredItems] = useState<any[]>([]);
  const [saving, setSaving] = useState(false);

  const onSelectItem = (id: number, text: string) => {
    setSaving(true);
    setValue(text);
    setShowList(false);
    onAdd(id);
  };

  const getFilteredItems = () => {
    let filtered = [...items];

    if (value.length > 0) {
      filtered = filtered.filter(item => `${item.user.firstName} ${item.user.lastName}`.toLowerCase().includes(value.toLowerCase())
        || item.user.email.toLowerCase().includes(value.toLowerCase()));
    }

    const dropdownItems: NvDropdownOption[] = filtered.map((item) => ({
      id: item.id,
      text: `${item.user.firstName} ${item.user.lastName}`,
      type: 'text',
      callback: () => onSelectItem(item.id, `${item.user.firstName} ${item.user.lastName}`),
    }));

    // Add header
    if (!dropdownItems.length) {
      dropdownItems.unshift({
        type: 'header',
        title: t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.AI_ASSISTANT.NO_MATCHES_FOUND(),
        id: 0,
      });
    }

    return dropdownItems;
  };

  useEffect(() => {
    if (!saving) {
      setShowList(value.length > 1);
      if (value.length > 1) {
        setFilteredItems(getFilteredItems());
      }
    }
  }, [value]);

  const changeHandler = (val: string) => setValue(val);

  return (
    <NvDropdown
      buttonStyle={NvDropdownButtonStyle.CUSTOM}
      minWidth={150}
      customTarget={() => (
        <EditTagField
          value={value}
          onClose={onCancel}
          onChange={changeHandler}
          disabled={saving}
        />
      )}
      align={NvDropdownAlign.LEFT}
      items={filteredItems}
      show={showList}
    />
  );
};

export default TagListAutocomplete;
